export enum ContaTipoGeradoPor {
	MANUALMENTE = <any>'manualmente',
	MOVIMENTACAO_NOTA_FISCAL = <any>'movimentacao_nota_fiscal',
	MOVIMENTACAO_ENTRADA = <any>'movimentacao_entrada',
	SISTEMA = <any>'sistema',
	REPLICADO = <any>'replicado',
}
